import { useRef, useState } from 'react';

const useProgressBar = (middlePercent: number, waitPercent: number, middleTime: number) => {
  const [percent, setPercent] = useState(0);
  const currentPercent = useRef(0);
  const interval = useRef<ReturnType<typeof setInterval> | null>(null);

  const intervalTime = 500;
  const maxRandom = middlePercent / (middleTime / intervalTime);
  const small = 0.1;

  const increase = (addedValue: number) => {
    currentPercent.current += addedValue;
    if (currentPercent.current >= 100) {
      currentPercent.current = 100;
    }
    setPercent(currentPercent.current);
  };

  const removeInterval = () => {
    if (interval.current) {
      clearInterval(interval.current);
      interval.current = null;
    }
  };

  const start = () => {
    interval.current = setInterval(() => {
      let addedValue: number;

      if (currentPercent.current >= waitPercent) {
        addedValue = 0;
      } else if (currentPercent.current >= middlePercent) {
        addedValue = small;
      } else {
        addedValue = Math.random() * maxRandom;
      }
      increase(addedValue);
    }, intervalTime);
  };

  const done = (doneCallback?: () => void) => {
    removeInterval();

    interval.current = setInterval(() => {
      if (currentPercent.current >= 100) {
        removeInterval();
        doneCallback?.();
        return;
      }
      increase(1);
    }, 50);
  };

  const restart = () => {
    removeInterval();
    currentPercent.current = 0;
    setPercent(0);

    start();
  };

  const stop = () => {
    removeInterval();
  };

  return {
    percent,
    done,
    start,
    restart,
    stop
  };
};

export default useProgressBar;
